import { createContext, useContext, useEffect, useState } from "react";

export const IpContext = createContext(null);
export const useIp = () => useContext(IpContext);

export function IpProvider({ children }) {
  const [ipAddress, setIpAddress] = useState(null);
  const port = 3001;

  useEffect(() => {
    async function loadIp() {
      try {
        const res = await fetch("/api/ip");
        const data = await res.json();
        setIpAddress(data.ip);
      } catch (err) {
        console.error("Failed to get IP", err);
      }
    }
    loadIp();
  }, []);

  return (
    <IpContext.Provider value={{ ipAddress, port }}>
      {children}
    </IpContext.Provider>
  );
}
